export default {
  title01: "현재 날씨",
  title02: "24시간",
  title03: "10일 간의 날씨 예보 보기",
  title04: "대기질 지수(AQI)",
  title05: "모든 정보 보기",
  title06: "일출 및 일몰",
  title07: "달의 위상",
  title08: "다음 보름달",
  title09: "다음 신월",
  title10: "낮",
  title11: "밤",
  title12: "일출",
  title13: "일몰",
  title14: "월출",
  title15: "월몰",
  title16: "출처",
  title17: "시작",
  title18: "종료",
  title19: "현재 위치 사용",
  title20: "도시 검색",
  title21: "체감 온도",
  title22: "그늘 체감 온도",
  title23: "현재",
  title24: "오늘",
  title25: "일",
  title26: "월",
  title27: "화",
  title28: "수",
  title29: "목",
  title30: "금",
  title31: "토",
  title32: "로딩 중...",
  title33: "지금",
  title34: "시간별",
  title35: "일별",
  title36: "해와 달",
  title37: "대기 질",
  title38: "문의: xlf550402@gmail.com",
  title39: "개인정보 보호 정책",
  title40: "저작권 © comfortweather.com 2020 - 2024. 모든 권리 보유.",
  title41: "제공된 데이터:",
  title42: "최고 기온",
  title43: "최저 기온",
  title44: "동의",
  title45:
    "ComfortWeather를 이용해 주셔서 감사합니다. 고객님의 법적 권리와 이익을 보다 잘 보호하기 위해, 사용 전에 반드시 ",
  title46: "개인정보 처리방침",
  title47: " 을 주의 깊게 읽어 주시기 바랍니다.",
  title48: "",
  title49: "문의: xyjph123@gmail.com",
  title50: "저작권 © 24hweather.com 2020 - 2024. 모든 권리 보유.",
  title51: "24hweather를 이용해 주셔서 감사합니다. 고객님의 법적 권리와 이익을 보다 잘 보호하기 위해, 사용 전에 반드시 ",
};
